import { useMemo, useState } from 'react'

import { CostCenterByLegalEntitiesDocument } from 'generated/resources/graphql'
import { debounce } from 'lodash'

import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'

export interface CostCenterOption {
  id: string
  name: string
}

interface Props {
  legalEntityIds: number[]
  excludeCostCenterIds: number[]
}

export const useCostCenterByLegalEntities = ({ excludeCostCenterIds, legalEntityIds }: Props) => {
  const [search, setSearch] = useState('')
  const debouncedOnSearch = useMemo(
    () =>
      debounce((val) => {
        setSearch(val)
      }, 200),
    []
  )

  const { nodes, controls, loading } = usePaginatedQuery(CostCenterByLegalEntitiesDocument, {
    variables: {
      legalEntityIds,
      search,
    },
    extractConnection: (data) => data.costCenters.costCentersConnection,
  })

  const costCenterOptions: CostCenterOption[] = nodes.map(
    (node): CostCenterOption => ({
      id: `${node.id}`,
      name: `${node.code ? `${node.code} - ${node.name}` : node.name}`,
    })
  )

  const filteredCostCenterOptions = costCenterOptions.filter(
    (op) => !excludeCostCenterIds.includes(Number(op.id))
  )

  return {
    controls,
    rawCostCenterOptions: costCenterOptions,
    debouncedOnSearch,
    filteredCostCenterOptions,
    loading,
  }
}
